import { navIconFor } from "../navigation/nav-icons";
import { EmptyState } from "../ui/empty-state";
import { Icon } from "../ui/icon";
import { PageHeader } from "../ui/page-header";

export type PlaceholderPageProps = Readonly<{
  title: string;
  description: string;
}>;

/**
 * A route that exists for the menu and has nothing behind it yet. It says so plainly: a title, the sentence about the area, and an empty
 * state that promises no feature. It holds no data and offers no command. The icon is the one of the menu entry (the entry keys are the
 * lower-case titles of these routes: "trips", "actions").
 */
export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  return (
    <section className="grid gap-5">
      <PageHeader eyebrow="Lafayette operations" title={title} description={description} />
      <div className="rounded-md border border-border bg-card shadow-sm">
        <EmptyState
          icon={<Icon name={navIconFor(title.toLowerCase())} />}
          title={`${title} is not available yet`}
          description="This Phase 1 route intentionally contains no downstream business commands or feature data."
        />
      </div>
    </section>
  );
}
